import React, { useState, useEffect } from 'react'
import { PDFViewer, Document, Page, View, Text, Image, pdf } from '@react-pdf/renderer';
// import { Table, TD, TH, TR } from "@ag-media/react-pdf-table";
import { styles } from './pdfstyles.jsx';
import FetchApi, { host } from '../../../../customhooks/Functionapi.jsx';
import { ItmeTypeID } from '../../newDocument/objectdata/typeobject';
import iconunclecked from '../../../../../images/326558_blank_check_box_icon.png';
import iconclecked from '../../../../../images/326561_box_check_icon.png';
import Pdfdocumentdetail from './pdfdocumentdetail.jsx';
import moment from 'moment/moment.js';

function Pdfdocument(props) {
    const [pdfData, setPdfData] = useState(null);

    useEffect(() => {
        // โหลดข้อมูลให้ครบทุกส่วน (หัว, รายละเอียด, รูป, ผู้อนุมัติ) ก่อน render pdf ครั้งเดียว
        loadPdfData(props.jourID).then(data => {
            setPdfData(data)
        })
    }, [props.jourID])

    return (
        <div style={{ height: 750 }}>
            {pdfData && <PDFViewer width="100%" height="100%" >
                <PdfDocumentContent {...pdfData} />
            </PDFViewer>}

        </div>
    )
}


// แปลงข้อมูลหัวเอกสารให้อยู่ในรูปแบบที่ pdf ใช้
const toJourHeader = (data) => {
    return {
        ...data,
        ItemTypeID: data.ItemTypeID == "" ? [] : data.ItemTypeID.split(','),
        PurposeDetail: data.PurposeDetail.split(",")
    }
}

// layout ของเอกสาร pdf ใช้ทั้งหน้าแสดง และสร้างไฟล์แนบส่งเมล
export function PdfDocumentContent({ jourHeader, allImages, datastepflow, dataDetial }) {

    const ClickTypeItem = (key) => {
        var typeItem = jourHeader.ItemTypeID.find(val => val == key);
        return typeItem;
    }

    return (
        <Document>
            <Page size="A4" style={styles.pageA4} wrap>
                {/* หัวกระดาษ แสดงทุกหน้า */}
                <View style={[styles.pageHeader, styles.textBoldfonts11]} fixed>
                    <View style={{ flexDirection: 'row' }}>
                        {jourHeader.statusflow == '105' ? <Text style={{ color: 'green' }}>ผ่านอนุมัติ</Text> : <Text style={{ color: 'red' }}>ยังไม่ผ่านอนุมัติ</Text>}
                        <Text style={{ marginLeft: 12 }}>เอกสาร : {jourHeader.JournalCode}</Text>
                    </View>
                    <Text render={({ pageNumber, totalPages }) => (
                        `${pageNumber} / ${totalPages}`
                    )} />
                </View>
                <View style={styles.textBoldfonts13}>


                    <View style={[styles.textBoldfonts11, { margin: 1, padding: 3, borderWidth: 1, borderColor: '#dddede' }]}>
                        <View style={[styles.textBoldfonts10, {
                            padding: 2,
                            flexDirection: 'row', justifyContent: 'space-between'
                        }]}>
                            <Text style={[styles.textBoldfonts14, { color: '#2980b9', fontWeight: '800' }]}>ส่วนของคำร้อง</Text>
                            <View style={[styles.textBoldfonts14, { padding: 2 }]}>
                                <Text style={{ color: '#2980b9', fontWeight: '800' }}>SPECFICATION SHEET</Text>
                            </View>
                        </View>
                        <View style={[styles.header, styles.textBoldfonts11, {
                            width: '100%',
                            borderBottomWidth: 1, borderBottomColor: '#dddede'
                        }]}>
                            <View style={{ width: '70%' }}>
                                <View style={styles.body}>
                                    <Text style={{ width: 60, fontWeight: 800 }}>ประเภทสินค้า</Text>

                                    {ItmeTypeID.map((val, index) => (
                                        <View style={{ padding: 5, marginRight: 5 }} key={index}>
                                            {ClickTypeItem(val) == val ?
                                                <View style={{ flexDirection: 'row' }}><Image src={iconclecked} style={{ width: 10, height: 10 }} /><Text > {val}</Text></View> :
                                                <View style={{ flexDirection: 'row' }}><Image src={iconunclecked} style={{ width: 10, height: 10 }} /><Text > {val}</Text></View>
                                            }
                                        </View>
                                    ))}
                                </View>
                                <View style={styles.body}>
                                    <Text style={{ width: 60, fontWeight: 800 }}>ประเภทงาน</Text>
                                    <Text> {jourHeader.TypeproductName} </Text>

                                    <View style={[styles.body, { marginLeft: 100 }]}>
                                        <Text style={{ width: 40, fontWeight: 800 }}>ผู้ร้องขอ</Text>
                                        <Text>{jourHeader.UserIDRequest}</Text>
                                    </View>

                                </View>

                                <View style={styles.body}>
                                    <Text style={{ width: 60, fontWeight: 800 }}>วัตถุประสงค์</Text>

                                    {jourHeader.PurposeDetail[0] !== "" && <View style={{ width: '25%', padding: 2 }}>
                                        {jourHeader.PurposeDetail.map((item, index) => (
                                            <View style={{ marginLeft: 25 }}>
                                                <Text>{index + 1}.{item}</Text>
                                            </View>
                                        ))}
                                    </View>}
                                    <View style={{ width: '100%', padding: 2 }}>
                                        <Text>{jourHeader.Purpose} </Text>
                                    </View>
                                </View>
                            </View>

                            <View style={{ width: '25%' }} >
                                <View style={styles.body}>
                                    <Text style={{ width: 70, fontWeight: 800 }}>วันที่สร้างเอกสาร</Text>
                                    <Text>{moment(jourHeader.TransDate).format('DD/MM/yyyy')}</Text>
                                </View>
                                <View style={styles.body}>
                                    <Text style={{ width: 70, fontWeight: 800 }}>วันที่ Approved</Text>
                                    <Text>{moment(jourHeader.LastApprovedDate).format('DD/MM/yyyy')}</Text>
                                </View>
                                <View style={styles.body}>
                                    <Text style={{ width: 70, fontWeight: 800 }}>เอกสารบรรจุ(SSD)</Text>
                                    <Text>{jourHeader.JournalCode}</Text>
                                </View>
                                {jourHeader.JournalGroupID != "" &&
                                    <View style={styles.body}>
                                        <Text style={{ width: 70, fontWeight: 800 }}>กลุ่มเอกสาร Revise</Text>
                                        <Text>{jourHeader.JournalGroupID}</Text>
                                    </View>}
                                <View style={styles.body}>
                                    <Text style={{ width: 70, fontWeight: 800 }}>เลขที่เอกสาร (ECN)</Text>
                                    <Text>{jourHeader.RefECN}</Text>
                                </View>
                            </View>

                        </View>

                        <View style={[styles.textBoldfonts10, { width: '100%', marginTop: 4 }]}>
                            <View style={styles.infoRow}>
                                <View style={[styles.infoCell, { width: '22%' }]}>
                                    <Text style={[styles.infoLabel, { width: 45 }]}>รหัสลูกค้า</Text>
                                    <Text style={styles.infoValue}>{jourHeader.CustID}</Text>
                                </View>
                                <View style={[styles.infoCell, { width: '50%' }]}>
                                    <Text style={[styles.infoLabel, { width: 40 }]}>ชื่อลูกค้า</Text>
                                    <Text style={styles.infoValue}>{jourHeader.CustName}</Text>
                                </View>
                                <View style={[styles.infoCell, { width: '28%' }]}>
                                    <Text style={[styles.infoLabel, { width: 40 }]}>ตราสินค้า</Text>
                                    <Text style={styles.infoValue}>{jourHeader.BrandID}</Text>
                                </View>
                            </View>
                            <View style={styles.infoRow}>
                                <View style={[styles.infoCell, { width: '22%' }]}>
                                    <Text style={[styles.infoLabel, { width: 45 }]}>รหัสสินค้า</Text>
                                    <Text style={styles.infoValue}>{jourHeader.ItemID}</Text>
                                </View>
                                <View style={[styles.infoCell, { width: '78%' }]}>
                                    <Text style={[styles.infoLabel, { width: 40 }]}>ชื่อสินค้า</Text>
                                    <Text style={styles.infoValue}>{jourHeader.ItemName}</Text>
                                </View>
                            </View>
                            <View style={styles.infoRow}>
                                <View style={[styles.infoCell, { width: '60%' }]}>
                                    <Text style={[styles.infoLabel, { width: 65 }]}>การบรรจุงาน</Text>
                                    <Text style={styles.infoValue}>{jourHeader.PackagingDetails}</Text>
                                </View>
                                <View style={[styles.infoCell, { width: '40%' }]}>
                                    <Text style={[styles.infoLabel, { width: 45 }]}>Spec Id</Text>
                                    <Text style={styles.infoValue}>{jourHeader.SpecId}</Text>
                                </View>
                            </View>
                            <View style={styles.infoRow}>
                                <View style={[styles.infoCell, { width: '60%' }]}>
                                    <Text style={[styles.infoLabel, { width: 65 }]}>อธิบายเพิ่มเติม 1</Text>
                                    <Text style={styles.infoValue}>{jourHeader.Remark}</Text>
                                </View>
                                <View style={[styles.infoCell, { width: '40%' }]}>
                                    <Text style={[styles.infoLabel, { width: 45 }]}>Spec Name</Text>
                                    <Text style={styles.infoValue}>{jourHeader.SpecName}</Text>
                                </View>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginTop: 2 }}>
                                <Text style={{ marginRight: 10 }}><Text style={{ fontWeight: 800 }}>ผู้อนุมัติ : </Text>{jourHeader.nameConfirme} {jourHeader.lastname}</Text>
                                <Text><Text style={{ fontWeight: 800 }}>วันที่สร้าง : </Text>{moment(jourHeader.TransDate).format('DD/MM/yyyy')}</Text>
                            </View>
                        </View>

                    </View>

                    <View>
                        {jourHeader.JournalID != "" && <Pdfdocumentdetail dataHeader={jourHeader} dataDetial={dataDetial} />}
                    </View>

                    {/* รูปภาพประกอบ ต่อเนื่องจากรายละเอียด */}
                    {allImages.length > 0 &&
                        <View style={styles.textBoldfonts10}>
                            {allImages.map((item, index) => (
                                <View key={index} wrap={false}>
                                {/* หัวข้อผูกกับรูปแรก ไม่ให้ค้างท้ายหน้าเดี่ยวๆ */}
                                {index === 0 && <View style={styles.sectionTitle}>
                                    <Text style={styles.textBoldfonts14}>รูปภาพประกอบ</Text>
                                </View>}
                                <View style={styles.imageRow}>
                                    <View style={styles.imageRowText}>
                                        <View>
                                            <Text style={styles.imageLabel}>หัวข้อ</Text>
                                            <Text style={styles.imageValue}>{item.SubjectDetails || '-'}</Text>
                                        </View>
                                        <View style={{ marginTop: 6 }}>
                                            <Text style={styles.imageLabel}>อธิบายเพิ่มเติม</Text>
                                            <Text style={[styles.imageValue, styles.imageValueFill]}>{(item.SubjectExtend || '-').replace(/\s*\n\s*/g, ' ')}</Text>
                                        </View>
                                        {!!item.ItemID && <View style={{ marginTop: 6 }}>
                                            <Text style={styles.imageLabel}>รหัสสินค้า</Text>
                                            <Text style={styles.imageValue}>{item.ItemID}</Text>
                                            <Text style={styles.imageValue}>{item.ItemName}</Text>
                                        </View>}
                                        {!!item.PkDescription && <View style={{ marginTop: 6 }}>
                                            <Text style={styles.imageLabel}>ภาพ</Text>
                                            <Text style={styles.imageValue}>{item.PkDescription}</Text>
                                        </View>}
                                    </View>
                                    <View style={styles.imageRowPic}>
                                        <Image src={`${host}/file/images/files/${item.LocationPic}`} style={styles.imageFit} />
                                    </View>
                                </View>
                                </View>
                            ))}
                        </View>
                    }

                    {/* ผู้อนุมัติ */}
                    {/* ไม่ใส่ wrap={false} ที่ View นอกสุด เพราะ react-pdf จะทำให้ส่วนท้ายเอกสารหายเมื่อต้องขึ้นหน้าใหม่ */}
                    {datastepflow.length > 0 &&
                        <View style={[styles.textBoldfonts10, { marginTop: 10 }]}>
                            <View style={styles.sectionTitle} minPresenceAhead={40}>
                                <Text style={styles.textBoldfonts14}>ผู้อนุมัติ</Text>
                            </View>
                            <View style={styles.approverRow} wrap={false}>
                                {datastepflow.map((item, index) => (
                                    <View key={index} style={styles.approverBox}>
                                        <Text style={styles.approverHead}>ผู้อนุมัติที่ {index + 1}</Text>
                                        <View style={styles.approverBody}>
                                            {/* เอกสารเก่าไม่มีชื่อผู้อนุมัติ แสดงเป็นแผนกแทน */}
                                            {item.userbyflow ?
                                                <Text>คุณ {item.userbyflow}</Text> :
                                                <Text>แผนก {item.departments}</Text>}
                                            {item.Enddatetime == null ?
                                                <Text style={{ color: '#c0392b' }}>ยังไม่อนุมัติ</Text> :
                                                <Text style={{ color: '#27ae60' }}>{moment(item.Enddatetime).format('DD/MM/yyyy')}</Text>}
                                        </View>
                                    </View>
                                ))}
                            </View>
                        </View>
                    }

                </View>
            </Page>

        </Document>
    )
}

// โหลดข้อมูลทั้งหมดของ pdf ใช้ทั้งหน้าแสดง และสร้างไฟล์แนบส่งเมล
async function loadPdfData(jourID) {
    const FetchApis = new FetchApi();
    const resHead = await FetchApis.FethcGet(`/document/DocumentById/${jourID}`);
    if (!resHead || !resHead.data || resHead.data.length == 0) {
        return null;
    }
    const jourHeader = toJourHeader(resHead.data[0]);

    const [resSpecific, resImages, resFlow, resDetail] = await Promise.all([
        FetchApis.FethcGet(`/document/DocumentSpecificByCode/${jourHeader.JournalCode}`),
        FetchApis.FethcGet(`/journalImages/JouranlImagesByCode/${jourHeader.JournalCode}`),
        FetchApis.FethcGet(`/flowrunsystem/flowSteplistByJourId/${jourID}`),
        FetchApis.FethcGet(`/document/DocumentdetailByCode/${jourHeader.JournalCode}`)
    ]);

    const allImages = [...(resSpecific?.data || []), ...(resImages?.data || [])];

    // เอกสารเก่า (นำเข้าจากระบบเดิม) ไม่มีข้อมูลผู้อนุมัติรายคน ใช้ลำดับแผนกจาก flow แทน
    let datastepflow = resFlow?.data || [];
    if (datastepflow.length === 0) {
        const resTemplate = await FetchApis.FethcGet(`/flowrunsystem/flowStepTemplateByJourId/${jourID}`);
        datastepflow = resTemplate?.data || [];
    }

    return {
        jourHeader: jourHeader,
        allImages: allImages,
        datastepflow: datastepflow,
        dataDetial: resDetail?.data || []
    };
}

// สร้างไฟล์ pdf ของเอกสาร (ไม่ต้องเปิดหน้าแสดง) ข้อมูลต้องโหลดให้ครบก่อน render
export async function buildPdfBlob(jourID) {
    const pdfData = await loadPdfData(jourID);
    if (!pdfData) {
        return null;
    }
    return pdf(<PdfDocumentContent {...pdfData} />).toBlob();
}

// approved คนสุดท้าย : สร้าง pdf แล้วส่งให้ backend ส่งเมลหาทุกคนใน flow
export async function sendEmailCompleted(jourID) {
    try {
        const blob = await buildPdfBlob(jourID);
        if (!blob) {
            return null;
        }
        const formData = new FormData();
        formData.append('journalId', jourID);
        formData.append('file', blob, `${jourID}.pdf`);
        return await new FetchApi().FethcPost(`/flowrunsystem/sendEmailCompleted`, formData);
    } catch (err) {
        console.log(err)
        return null;
    }
}

// approved / reject แต่ละขั้น : ให้ backend ส่งเมลแจ้งเตือน (ไม่แนบ pdf ลดปัญหาไฟล์ใหญ่ / ส่งช้า)
// แนบ pdf เฉพาะเมล approved ครบทุกขั้น (sendEmailCompleted)
// mailData = { userId, stateflow, typeEvent: 'approved' | 'reject', rejectTo }
export async function sendEmailStep(jourID, mailData) {
    try {
        return await new FetchApi().FethcPost(`/flowrunsystem/sendEmailStep`, {
            journalId: jourID,
            userId: mailData.userId,
            stateflow: mailData.stateflow,
            typeEvent: mailData.typeEvent,
            rejectTo: mailData.rejectTo || ''
        });
    } catch (err) {
        console.log(err)
        return null;
    }
}

export default Pdfdocument